/* eslint-disable */
import { v5 as uuidv5 } from 'uuid';

export default uuidv5;
